"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSplAddressLookupTableProgramId = exports.getSplAddressLookupTableProgram = exports.createSplAddressLookupTableProgram = exports.SPL_ADDRESS_LOOKUP_TABLE_PROGRAM_ID = void 0;
const errors_1 = require("../errors");
exports.SPL_ADDRESS_LOOKUP_TABLE_PROGRAM_ID = 'AddressLookupTab1e1111111111111111111111111';
function createSplAddressLookupTableProgram() {
    return {
        name: 'splAddressLookupTable',
        publicKey: exports.SPL_ADDRESS_LOOKUP_TABLE_PROGRAM_ID,
        getErrorFromCode(code, cause) {
            return (0, errors_1.getSplAddressLookupTableErrorFromCode)(code, this, cause);
        },
        getErrorFromName(name, cause) {
            return (0, errors_1.getSplAddressLookupTableErrorFromName)(name, this, cause);
        },
        isOnCluster() {
            return true;
        },
    };
}
exports.createSplAddressLookupTableProgram = createSplAddressLookupTableProgram;
function getSplAddressLookupTableProgram(context, clusterFilter) {
    return context.programs.get('splAddressLookupTable', clusterFilter);
}
exports.getSplAddressLookupTableProgram = getSplAddressLookupTableProgram;
function getSplAddressLookupTableProgramId(context, clusterFilter) {
    return context.programs.getPublicKey('splAddressLookupTable', exports.SPL_ADDRESS_LOOKUP_TABLE_PROGRAM_ID, clusterFilter);
}
exports.getSplAddressLookupTableProgramId = getSplAddressLookupTableProgramId;
//# sourceMappingURL=splAddressLookupTable.js.map